var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 190.784,
    height: 128.412,
    viewBox: "0 0 190.784 128.412",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#028120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00be2c"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_160",
    x: 105,
    y: 68,
    width: 43,
    height: 43,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_402",
    "data-name": "Group 402",
    transform: "translate(-855 -360)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_401",
    "data-name": "Group 401",
    transform: "translate(-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_655",
    "data-name": "Path 655",
    d: "M8556.913-908.251c15.267,2.665,74.017,29.381,98.388-8.949s45.2-25.825,34.2-48.445-63.651-55.164-108.22-25.8-72.763,1.894-78.97,18.246S8541.646-910.916,8556.913-908.251Z",
    transform: "translate(-7633.733 1385.129)",
    fill: "#fbf8ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_405",
    "data-name": "Group 405",
    transform: "translate(465.155 360)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_164",
    "data-name": "Ellipse 164",
    cx: 10.686,
    cy: 10.686,
    r: 10.686,
    transform: "translate(488.46 6.52)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_681",
    "data-name": "Path 681",
    d: "M843.169,301.692s2.013,15.177-1.084,16.88,18.429,1.858,18.429,1.858-4.8-13.163-2.633-17.19Z",
    transform: "translate(-351.999 -279.143)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_682",
    "data-name": "Path 682",
    d: "M827.205,357.536l-1.79,8.152-3.785,17.247-.113.945-1.306,10.935-.869,7.264-.583,4.88c-3.543,1.821-6.11,3.078-6.11,3.078s-.221-1.107-.577-2.524a54.186,54.186,0,0,1-10.986,2.229c1.42,1.582,2.072,3.069,1.187,4.166-2.671,3.307-13.7-3.621-17.554-6.2a10.441,10.441,0,0,0-.1,1.869l-2.951-2.27.292-5.222.493-8.836.619-11.081a11.634,11.634,0,0,1-.49-1.457c-.9-3.214-2-9.633-2.842-15.015-.677-4.332-1.186-7.992-1.293-8.771l-.022-.154,16.337-7.219c1.161,2.693,6.583,3.5,6.583,3.5a18.183,18.183,0,0,0,8.012-2.678Z",
    transform: "translate(-302.972 -316.172)",
    fill: "#d0cde1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_683",
    "data-name": "Path 683",
    d: "M868.218,586.279s-.692.237-1.816.573a54.184,54.184,0,0,1-10.986,2.229c-3.357.215-6.193-.3-6.712-2.492a2.314,2.314,0,0,1,.78-2.353c2.052-1.9,7.411-2.584,11.661-2.818,1.2-.065,2.31-.1,3.235-.108,1.569-.02,2.6.012,2.6.012l.025.1Z",
    transform: "translate(-357.302 -495.512)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_684",
    "data-name": "Path 684",
    d: "M834.2,209.1l-2-.8s4.177-4.6,9.99-4.2l-1.635-1.8s4-1.6,7.628,2.6a35.455,35.455,0,0,1,5.5,7.725h2.14l-.893,1.966,3.126,1.966-3.208-.353a10.989,10.989,0,0,1,.087,3.262,4.22,4.22,0,0,1-1.545,2.761h0s-2.478-5.129-2.478-5.929v2s-2-1.8-2-3l-1.09,1.4-.545-2.2-6.72,2.2,1.09-1.8-4.177.6,1.635-2.2s-4.722,2.6-4.9,4.8a10.561,10.561,0,0,1-1.564,4.284S828.935,212.1,834.2,209.1Z",
    transform: "translate(-343.946 -202)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_685",
    "data-name": "Path 685",
    d: "M944.786,422.356a37.657,37.657,0,0,1-7.055,4.881c-1.216.715-2.511,1.452-3.832,2.184-3.152,1.748-6.452,3.48-9.175,4.88-3.543,1.821-6.11,3.078-6.11,3.078s-.221-1.107-.577-2.524a20.925,20.925,0,0,0-1.943-5.433c-.026-.038-.052-.073-.078-.108-.218-.286-.437-.453-.654-.453l10.814-6.7,4.673-2.9-3.367-8.037-4.223-10.082,2.549-8.11,2.562-8.152h4.8s1.59,3.47,3.623,8.309c.3.724.618,1.478.937,2.257C941.913,405.616,947.127,419.82,944.786,422.356Z",
    transform: "translate(-408.938 -343.514)",
    fill: "#d0cde1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_686",
    "data-name": "Path 686",
    d: "M819.23,588.542c-2.671,3.307-13.7-3.621-17.554-6.2-.84-.562-1.34-.918-1.34-.918l3.528-4.705,1.117-1.489s1,.53,2.478,1.394l.163.1c1.274.748,2.874,1.726,4.489,2.818a33.874,33.874,0,0,1,5.932,4.845C819.463,585.959,820.115,587.445,819.23,588.542Z",
    transform: "translate(-319.929 -490.808)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_687",
    "data-name": "Path 687",
    d: "M744.59,427.207a6.938,6.938,0,0,0-1.177.1c-3.341.574-4.326,3.6-4.606,5.624a10.441,10.441,0,0,0-.1,1.869l-2.951-2.27-1.075-.827a19.6,19.6,0,0,1-6.894-4.4,34.657,34.657,0,0,1-4.643-5.506,48.566,48.566,0,0,1-3.592-6.161,4.531,4.531,0,0,1-.062-3.844l3.655-8.145,5.342-11.9q.059-.425.129-.831c1.059-6.074,3.9-8.771,3.9-8.771h2.168l1.45,8.771,1.8,10.9-1.263,4.118-2.918,9.511,2.789,3.028Z",
    transform: "translate(-257.059 -341.397)",
    fill: "#d0cde1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_688",
    "data-name": "Path 688",
    d: "M825.924,451.06l1.853,2.162c.689-.131,1.408-.286,2.148-.459l-.532-1.7,1.3,1.519a175.806,175.806,0,0,0,17.572-5.682s-10.5.77-18.34-.943a7.46,7.46,0,0,0-8.461,4.214c-.827,1.891-.7,3.529,2.237,3.529a19.383,19.383,0,0,0,2.957-.278Z",
    transform: "translate(-335.939 -390.638)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_689",
    "data-name": "Path 689",
    d: "M794.135,617.905v.882a1.937,1.937,0,0,1-.132.708,2,2,0,0,1-.141.291,1.953,1.953,0,0,1-1.678.953H727.295a1.953,1.953,0,0,1-1.678-.953,1.991,1.991,0,0,1-.141-.291,1.94,1.94,0,0,1-.132-.708v-.882a1.951,1.951,0,0,1,1.952-1.951h3.74v-.411a.081.081,0,0,1,.081-.081h1.952a.081.081,0,0,1,.081.081v.411h1.219v-.411a.081.081,0,0,1,.081-.081H736.4a.081.081,0,0,1,.081.081v.411H737.7v-.411a.081.081,0,0,1,.081-.081h1.952a.081.081,0,0,1,.081.081v.411h1.219v-.411a.081.081,0,0,1,.081-.081h1.952a.081.081,0,0,1,.081.081v.411h1.219v-.411a.081.081,0,0,1,.081-.081H746.4a.081.081,0,0,1,.081.081v.411h1.221v-.411a.081.081,0,0,1,.081-.081h1.952a.081.081,0,0,1,.081.081v.411h1.219v-.411a.081.081,0,0,1,.081-.081h15.287a.081.081,0,0,1,.081.081v.411h1.221v-.411a.081.081,0,0,1,.081-.081h1.952a.082.082,0,0,1,.081.081v.411h1.219v-.411a.081.081,0,0,1,.081-.081h1.952a.081.081,0,0,1,.081.081v.411h1.219v-.411a.081.081,0,0,1,.081-.081h1.952a.081.081,0,0,1,.081.081v.411h1.221v-.411a.081.081,0,0,1,.081-.081h1.952a.081.081,0,0,1,.08.081v.411h1.221v-.411a.081.081,0,0,1,.081-.081h1.952a.081.081,0,0,1,.081.081v.411h1.219v-.411a.081.081,0,0,1,.081-.081h1.952a.081.081,0,0,1,.081.081v.411h5.692a1.951,1.951,0,0,1,1.952,1.952Z",
    transform: "translate(-261.898 -521.944)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    d: "M797.437,460.332H773.251v-.5H762.284v.5H738a1.636,1.636,0,0,0-1.636,1.636v33.118A1.636,1.636,0,0,0,738,496.722h59.439a1.636,1.636,0,0,0,1.636-1.636V461.968a1.636,1.636,0,0,0-1.636-1.636Z",
    transform: "translate(-270.425 -401.516)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_165",
    "data-name": "Ellipse 165",
    cx: 3.633,
    cy: 3.633,
    r: 3.633,
    transform: "translate(493.708 66.745)",
    fill: "none",
    stroke: "#d0cde1",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_166",
    "data-name": "Ellipse 166",
    cx: 3.633,
    cy: 3.633,
    r: 3.633,
    transform: "translate(492.545 68.053)",
    fill: "#d0cde1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_459",
    "data-name": "Rectangle 459",
    width: 73.091,
    height: 0.452,
    transform: "translate(460.845 97.711)",
    fill: "#3f3d56"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_403",
    "data-name": "Group 403",
    transform: "translate(-74 -9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 929, 369)",
    filter: "url(#Ellipse_160)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_160-2",
    "data-name": "Ellipse 160",
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    transform: "translate(114 77)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun_tick_2758597_1_",
    "data-name": "noun_tick_2758597 (1)",
    transform: "matrix(0.996, 0.087, -0.087, 0.996, 1050.917, 450.529)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_656",
    "data-name": "Path 656",
    d: "M.012,8.64l3.626,4.306s3.3-6.8,7.3-10.227a.11.11,0,0,0-.126-.18c-3.867,2.254-7.826,7.616-7.826,7.616L.076,8.563A.051.051,0,0,0,.012,8.64Z",
    transform: "translate(0)",
    fill: "#f5f7fa"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.857a60e9.svg";
export { ForwardRef as ReactComponent };